import React, { useEffect } from 'react';
import  { Link } from 'react-router-dom'
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { authLout } from "../../actions";


const mapStateToProps = (state) => ({
    uType: state.auth.uType
});

const mapDispatchToProps = (dispatch) => ({
    authLout: payload => dispatch(authLout(payload)),  
});

const Logout = ({ uType, authLout }) => {

    useEffect(function() {
        // console.log('itemId');
        // console.log(itemId);                
        if (uType!=='') {
            authLout();
        }
    }, [uType]);

    return (
        <Container>
            <Row style={{ 'marginTop': '2em', textAlign: 'center' }}>
                <Col xs={12} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                    Uspesna odjava.<br />                       
                    <Link to="/l-in" style={{ marginTop: '1em' }}>
                        Uloguj se
                    </Link>        
                </Col>
            </Row>
        </Container>
    );

}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
